import { BaseLogicExpression } from "./BaseLogic";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import { BooleanDataDefinition } from "../../../Common/Data/Definitions/BooleanDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class LessThanExpression extends BaseLogicExpression {
    readonly __type: string = "Less Than";
    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1", new NumberDataDefinition());
        this.value2 = ExpressionValue.createExpressionValue(this, "value2", new NumberDataDefinition());
        this.expressionValueType = new BooleanDataDefinition();
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext) < this.value2.evaluate(data, testContext);
    }
}
